module.exports = __webpack_public_path__ + "media/packs/images/partners/partner3-4b2c99d65ab0e39219d0f36224d89d73.jpg";